import { FC } from "react";
import PartyLedger from "../../components/Reports/PartyLedgerDN";
import PartyLedgerReport from "../../components/Reports/PartyLedger";
import PartyWiseOutstanding from "../../components/Reports/PartyWiseOutstanding";
import ReportData from '../../components/Reports/ReportData';
import ReportDashboard from '../../components/Reports/ReportDashboard';
import { ReportTypes, VocuherCategory } from '../../utils/common-utils';

interface ReportProps {
  type: string;
}

const Reports: FC<ReportProps> = ({ type }) => {
  return (
    <>
      {type == 'Dashboard' && <ReportDashboard type={'Dashboard'}/>}
      {type == VocuherCategory.SALE && <ReportData type={VocuherCategory.SALE} />}
      {type == VocuherCategory.PURCHASE && <ReportData type={VocuherCategory.PURCHASE} />}
      {type == ReportTypes.PARTY_LEDGER && <PartyLedger type={ReportTypes.PARTY_LEDGER} />}
      {type == ReportTypes.PARTY_LEDGER_REPORT && <PartyLedgerReport type={ReportTypes.PARTY_LEDGER_REPORT} />}
      {type == ReportTypes.PARTY_WISE_OUTSTANDING && <PartyWiseOutstanding type={ReportTypes.PARTY_WISE_OUTSTANDING} />}
    </>
  );
};
export default Reports;